import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EyeOffIcon, EyeOnIcon } from 'assets/icons';
import { FormField, IFormInput } from 'common/components/form/Wrapper';

type IPasswordField = Omit<IFormInput, 'type' | 'icon' | 'max' | 'min' | 'step' | 'placeholder'>;

const icons = {
  true: EyeOnIcon,
  false: EyeOffIcon,
};

export const PasswordField = ({ name, ...rest }: IPasswordField) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const type = showPassword ? 'text' : 'password';
  const Icon = icons[`${showPassword}`];

  return (
    <FormField
      {...rest}
      name={name}
      type={type}
      placeholder={t('Password')}
      onIconClick={() => setShowPassword(!showPassword)}
      icon={<Icon width={16} height={16} strokeWidth={1.5} stroke="currentColor" />}
    />
  );
};
